import { render, staticRenderFns } from "./MedalPopup.vue?vue&type=template&id=056fd911&"
import script from "./MedalPopup.vue?vue&type=script&lang=js&"
export * from "./MedalPopup.vue?vue&type=script&lang=js&"
import style0 from "./MedalPopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports